import React, { useState } from 'react'
import DataTable from './DataTable'
import { KTSVG } from '../../_metronic/helpers'
import ItemBomCreateModal from './ItemBomCreateModal'
import { Link } from 'react-router-dom'
import 'react-loading-skeleton/dist/skeleton.css'

const FormulationBomList = () => {
	const [newData, setNewData] = useState<any>({})
	const [showItemBomCreateModal, setShowItemBomCreateModal] = useState(false)
	const [bomCreateItem, setBomCreateItem] = useState<any>(null)

	const reloadTable = () => setNewData({ id: Date.now() })

	const showBomCreator = (row: any) => {
		setBomCreateItem({
			idItems: row.idItems,
			itemName: row.itemName,
		})
		setShowItemBomCreateModal(true)
	}

	const handleItemBomCreateClose = (saved?: boolean) => {
		setShowItemBomCreateModal(false)
		setBomCreateItem(null)
		if (saved) {
			reloadTable()
		}
	}

	const parseBomList = (bomList: string | null) => {
		if (!bomList) {
			return []
		}
		return bomList.split('|').map((entry) => {
			const [id, ...nameParts] = entry.split(':')
			return { id: Number(id), name: nameParts.join(':') }
		}).filter((bom) => bom.id && bom.name)
	}

	const columns = [
		{ value: 'id', title: 'Id', style: { textAlign: 'center' } },
		{ value: 'itemName', title: 'Name', style: { textAlign: 'left' } },
		{ value: 'itemCode', title: 'Code', style: { textAlign: 'left' } },
		{ value: 'productGradeName', title: 'Product Grade', style: { textAlign: 'left' } },
		{ value: 'unitName', title: 'Unit', style: { textAlign: 'left' } },
		{
			value: 'bomSetup',
			title: 'BOM',
			style: { textAlign: 'center', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: (row: any) => {
				const boms = parseBomList(row.bomList)
				if (boms.length > 0) {
					return (
						<div>
							{boms.map((bom, bomIndex) => (
								<React.Fragment key={bom.id}>
									{bomIndex > 0 && <hr className="my-1" />}
									<Link to={`/item-bom-formulation/${row.idItems}?id_item_bom=${bom.id}`}>
										{bom.name}
									</Link>
								</React.Fragment>
							))}
						</div>
					)
				}
				return (
					<button type="button" className="btn btn-warning btn-sm" onClick={() => showBomCreator(row)}>
						Create BOM
					</button>
				)
			},
		},
	]

	const filters = {
		id: { filterType: 'like', filterValue: '' },
		itemName: { filterType: 'like', filterValue: '' },
		itemCode: { filterType: 'like', filterValue: '' },
		productGradeName: { filterType: 'like', filterValue: '' },
		unitName: { filterType: 'like', filterValue: '' },
		bomSetup: { filterType: 'like', filterValue: '' },
	}

	const url = process.env.REACT_APP_API_URL + 'item-bom-list'

	return (
		<>
			<div className="card card-custom">
				<div className="card-header">
					<div className="card-title">
						<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
						<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
							Formulation BOM
						</span>
					</div>
				</div>

				<div className="card-body">
					<DataTable
						url={url}
						columns={columns}
						filters={filters}
						newData={newData}
					/>
				</div>
			</div>

			<ItemBomCreateModal
				show={showItemBomCreateModal}
				handleClose={handleItemBomCreateClose}
				item={bomCreateItem}
				defaultBomName="Default BOM"
			/>
		</>
	)
}

export default FormulationBomList
